import { api } from "@/api/client";

export type OraclePool = {
  code: string;
  title?: string;
  kind?: string;
  token_symbol?: string;
  tvl_usdt?: number;
  bsc_usdt_address?: string;
  description?: string;
  min_deposit_usdt?: number;
  live_mint_enabled?: boolean;
  performance_score?: number | null;
  rating_count?: number;
  withdraw_requires_stars?: boolean;
  tiers?: { label?: string; lock_days?: number; unlock_days?: number; yield_apy_bps?: number }[];
};

export type OraclePosition = {
  id: number;
  pool_id?: number;
  amount_usdt?: number;
  status?: string;
  claimable_usdt?: number;
  redeemed_usdt?: number;
  minted_token_symbol?: string;
  lock_days?: number;
  unlock_days?: number;
};

export type OracleAct = {
  id: number;
  stars?: number;
  caption?: string | null;
  twin_status?: string;
  created_at?: string | null;
};

export async function listOraclePools(): Promise<OraclePool[]> {
  const out = await api<{ pools: OraclePool[] }>("/oracle-pools");
  return out.pools || [];
}

export async function getOraclePool(code: string): Promise<OraclePool> {
  const out = await api<{ pool: OraclePool }>(`/oracle-pools/${encodeURIComponent(code)}`);
  return out.pool;
}

export async function listOraclePositions(
  token: string,
  code: string
): Promise<OraclePosition[]> {
  const out = await api<{ items?: OraclePosition[] }>(
    `/oracle-pools/${encodeURIComponent(code)}/positions`,
    {},
    token
  );
  return out.items || [];
}

export async function listOracleActs(code: string): Promise<OracleAct[]> {
  const out = await api<{ items?: OracleAct[] }>(
    `/oracle-pools/${encodeURIComponent(code)}/acts`
  );
  return out.items || [];
}

export async function completeOracleWithdraw(
  token: string,
  code: string,
  body: {
    position_id: number;
    stars: number;
    caption?: string;
    burn_amount?: number;
    force_unlock?: boolean;
  }
): Promise<unknown> {
  return api(
    `/oracle-pools/${encodeURIComponent(code)}/withdraw/complete`,
    { method: "POST", body: JSON.stringify(body) },
    token
  );
}
